<template>
  <div class="text-center">
    <div
      v-for="(question, index) in questions"
      v-show="question.id == selectedQuestion.id"
    >
      <h4 class="question_text">
        {{ question.question }} <a
          v-if="canDeleteQuestion"
          :title="trans('core.delete_object', { 'object': trans_choice('core.questions', 1) })"
          @click="$emit('deleteQuestion',{ question:question, index:index })"
        ><span
          class="fa fa-trash pointer"
        /></a>
      </h4>
      <component
        :is="questionTypeComponent(question.type)"
        :responses="question.responses"
        :answers="question.answers"
        :remarks="question.remarks || []"
      />
    </div>
    <ul
      v-show="numberOfQuestions > 1"
      class="pagination pagination__center"
    >
      <span
        v-for="(question, index) in questions"
        class="question-changer pointer fa"
        :class="getSquare(selectedQuestion.id == question.id)"
        @click="changeQuestionIndex(index)"
      />
    </ul>
  </div>
</template>

<script>
import LikeQuestionResult from '../../components/results/employees/LikeQuestionResult'
import FiveScaleQuestionResult from '../../components/results/employees/FiveScaleQuestionResult'
import OpenQuestionResult from '../../components/results/employees/OpenQuestionResult'
import TenScaleQuestionResult from '../../components/results/employees/TenScaleQuestionResult'
import SixScaleQuestionResult from '../../components/results/employees/SixScaleQuestionResult'
import SelectOneQuestionResult from '../../components/results/students/SelectOneQuestionResult'

export default {
  name: 'BaseResult',
  components: {
    SixScaleQuestionResult,
    TenScaleQuestionResult,
    LikeQuestionResult,
    FiveScaleQuestionResult,
    OpenQuestionResult,
    SelectOneQuestionResult
  },
  props: {
    event_id: { default: 0 },
    can_delete: { default: 0 },
    questions: { type: Array, required: false, default: {} },
  },
  data () {
    return {
      question_index: 0,
    }
  },
  computed: {

    numberOfQuestions () {
      if (this.questions == null) {
        return 0
      } else {
        return this.questions.length
      }
    },
    selectedQuestion () {
      if (this.question_index == null || this.questions[this.question_index] == null) {
        return null
      }

      return this.questions[this.question_index]
    },
    canDeleteQuestion () {
      if (!this.can_delete || this.questions == null || this.event_id === 0 || this.selectedQuestion == null) {
        return false
      }
      return this.selectedQuestion.responses.responses == 0 && this.selectedQuestion.can_delete === true
    },
  },
  methods: {
    changeQuestionIndex (index) {
      this.question_index = index
    },
    getSquare (value) {
      return value ? 'fa-square' : 'fa-square-o'
    },
    questionTypeComponent (type) {
      if (type === 'like') {
        return 'LikeQuestionResult'
      } else if (type === 'five_scale') {
        return 'FiveScaleQuestionResult'
      } else if (type === 'six_scale') {
        return 'SixScaleQuestionResult'
      } else if (type === 'ten_scale') {
        return 'TenScaleQuestionResult'
      } else if (type === 'open') {
        return 'OpenQuestionResult'
      } else if (type === 'select_one') {
        return 'SelectOneQuestionResult'
      }
    },

  },
}
</script>

<style lang="scss" scoped>
  .fa-trash {
    color: #b71c1c;
  }

.pointer {
  cursor: pointer;
}

.question-changer {
  padding-right: 2px;
  padding-left: 5px;
  color: #e1e1e1;
  font-size: 15px
}

.pagination {
  margin-bottom: 0px;
}
</style>
